import Image from '@/core/components/Image/Image';

export default Image;
